import {
  BodyLG,
  BodyLGB,
  BodyMDB,
  BodyXL,
  Heading2XL,
  Heading5XL,
} from "../../../typography";

import { Link } from "react-router-dom";
import { RiveAnimation } from "../../components/ui/RiveAnimation";
import { StandardButton } from "@verse_core/shared_components/buttons/StandardButton";

const SECTION_LABEL = "For Payors";
const SECTION_TITLE =
  "Improve the care quality and financial performance of your DME network.";
const SECTION_DESCRIPTION =
  "Verse is your partner in DME cost reduction and care delivery.";
const BUTTON_TEXT = "Connect with our team";

export const Hero = () => (
  <div className="tw-relative tw-flex tw-items-center tw-gap-y-[32px]">
    <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-x-[16px] tw-gap-y-[42px] min440:tw-flex-row min440:tw-px-[24px]">
      <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-y-[1.5em] tw-text-center min440:tw-w-1/2 min440:tw-items-start min440:tw-text-left">
        <Heading2XL className="tw-my-0 tw-hidden tw-w-full tw-text-white min1040:tw-flex">
          {SECTION_LABEL}
        </Heading2XL>
        <BodyXL className="tw-my-0 tw-w-full tw-text-white min1040:tw-hidden">
          {SECTION_LABEL}
        </BodyXL>
        <Heading5XL className="tw-my-0 tw-hidden tw-w-full tw-text-white min1040:tw-flex">
          {SECTION_TITLE}
        </Heading5XL>
        <Heading2XL className="tw-my-0 tw-w-full tw-text-white min1040:tw-hidden">
          {SECTION_TITLE}
        </Heading2XL>

        <BodyXL className="tw-my-0 tw-hidden tw-w-full tw-text-white min1040:tw-flex">
          {SECTION_DESCRIPTION}
        </BodyXL>
        <BodyLG className="tw-my-0 tw-w-full tw-text-white min1040:tw-hidden">
          {SECTION_DESCRIPTION}
        </BodyLG>

        <StandardButton
          onClick={() => {}}
          style={"primary-blue"}
          className="tw-w-[15em] tw-rounded-full tw-px-[2em] tw-py-[1em] tw-text-[16px]"
        >
          <Link to="/contact" className="tw-no-underline">
            <BodyLGB className="tw-my-0 tw-hidden tw-text-white min440:tw-block">
              {BUTTON_TEXT}
            </BodyLGB>
            <BodyMDB className="tw-my-0 tw-text-white min440:tw-hidden">
              {BUTTON_TEXT}
            </BodyMDB>
          </Link>
        </StandardButton>
      </div>
      <div className="tw-flex tw-aspect-square tw-w-full min440:tw-w-1/2">
        <RiveAnimation
          src="/landing_page_assets/rive/10.riv"
          className="tw-h-full tw-w-full"
          fallbackSrc="/landing_page_assets/payor_network_page/img1.png"
          fallbackClassName="tw-h-full tw-w-full"
        />
        <div className="tw-absolute tw-aspect-video tw-w-screen min440:tw-right-[-80px] min440:tw-max-w-[1038px]">
          <img
            src="/landing_page_assets/payor_network_page/country.svg"
            alt={SECTION_TITLE}
            className="tw-h-full tw-w-full"
          />
        </div>
      </div>
    </div>
  </div>
);
